import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: number | string;
  color?: string;
};
const DefaultColor = "#0061ff";
function AST({
  size = 16,
  color = DefaultColor
}: Props): JSX.Element {
  return <Svg width={size} height={size} viewBox="0 0 24 24" fill={color}><path  d="M12.008 4.5l7.492 7.605-.281.255q-.192.18-.4.345A10.7 10.7 0 0114.61 14.8a11 11 0 01-2.602.316c-1.11 0-2.213-.165-3.27-.503a10.7 10.7 0 01-3.025-1.51 14 14 0 01-.924-.742l-.289-.256.821-.834zm6.553 7.852c.111-.09.221-.18.318-.277L12 5.108l-6.878 6.967.14.12c.23.188.458.375.695.54a10.3 10.3 0 006.05 1.937c.846 0 1.688-.104 2.508-.307a10.4 10.4 0 003.313-1.472q.38-.25.733-.54m-11.272-.36a11.45 11.45 0 014.6-.99c1.865 0 3.698.495 5.303 1.441l.105.06-.105.068a9.7 9.7 0 01-3.483 1.374l-.03.007-.022-.015a11.9 11.9 0 00-6.295-1.802h-.407zm6.479 1.502a8.8 8.8 0 002.662-.968 10 10 0 00-4.548-1.09c-.953 0-1.9.128-2.818.383 1.665.225 3.265.795 4.704 1.675m2.478 1.479q-.502.682-1.065 1.314L12.008 19.5l-2.234-2.26.473-.03a10.3 10.3 0 004.49-1.344c.414-.202 1.509-.893 1.509-.893m-5.51 2.628l1.271 1.29 2.249-2.281a10.7 10.7 0 01-3.52.991" /></Svg>;
}
AST.DefaultColor = DefaultColor;
export default AST;